import { render } from "./HomeView.vue?vue&type=template&id=bb1b543c&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=bb1b543c&scoped=true&lang=css"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb1b543c"]])

export default __exports__